// extracted by mini-css-extract-plugin
export var active = "sub-navigation-module--active--7a7b3";
export var annualEvents = "sub-navigation-module--annual-events--affc5";
export var annualNews = "sub-navigation-module--annual-news--3a430";
export var annualProjects = "sub-navigation-module--annual-projects--820ba";
export var astext = "sub-navigation-module--astext--cc18e";
export var backgroundImage = "sub-navigation-module--background-image--ac50e";
export var btnClose = "sub-navigation-module--btn-close--da462";
export var btnOutlineLsuGold = "sub-navigation-module--btn-outline-lsu-gold--76c6b";
export var btnOutlineLsuPurple = "sub-navigation-module--btn-outline-lsu-purple--9b71d";
export var btnPrimary = "sub-navigation-module--btn-primary--5353d";
export var btnSecondary = "sub-navigation-module--btn-secondary--59c6d";
export var dmaeLogo = "sub-navigation-module--dmae-logo--e0029";
export var eventBlog = "sub-navigation-module--event-blog--8f4e2";
export var h1 = "sub-navigation-module--h1--cf097";
export var h2 = "sub-navigation-module--h2--aadbe";
export var h3 = "sub-navigation-module--h3--026da";
export var h4 = "sub-navigation-module--h4--8f5b4";
export var h5 = "sub-navigation-module--h5--7b979";
export var h6 = "sub-navigation-module--h6--bd788";
export var hover = "sub-navigation-module--hover--803bf";
export var icon = "sub-navigation-module--icon--cee61";
export var menu = "sub-navigation-module--menu--58f4e";
export var navLink = "sub-navigation-module--nav-link--98693";
export var navbarDark = "sub-navigation-module--navbar-dark--7f674";
export var navbarNav = "sub-navigation-module--navbar-nav--045f4";
export var navbarToggler = "sub-navigation-module--navbar-toggler--b13d0";
export var navbarTogglerIcon = "sub-navigation-module--navbar-toggler-icon--59607";
export var newsArticle = "sub-navigation-module--news-article--8b936";
export var newsEventsEvents = "sub-navigation-module--news-events-events--cc8d6";
export var newsEventsNews = "sub-navigation-module--news-events-news--5d627";
export var pageItem = "sub-navigation-module--page-item--ec570";
export var pageLink = "sub-navigation-module--page-link--e92ba";
export var projectPost = "sub-navigation-module--project-post--c76fa";
export var socialText = "sub-navigation-module--social-text--47888";
export var textLight = "sub-navigation-module--text-light--1e73b";
export var textLsuLightGold = "sub-navigation-module--text-lsu-light-gold--42f53";
export var textWhite = "sub-navigation-module--text-white--723a9";
export var topNavigation = "sub-navigation-module--top-navigation--13d21";
export var txt = "sub-navigation-module--txt--118fa";
export var underline = "sub-navigation-module--underline--c3d00";